import styled from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'

export const Wrapper = styled.div`
  padding: 40px 30px !important;
  min-height: 65vh;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  text-align: center;

  p {
    font: ${font('default', 'normal', '24px/1.3')};
    color: ${props => props.theme.palette.general.light};
    ${bp('lg', 'min-width')`
      font: ${font('default', 'medium', '2vw/1.5')};
    `}

    strong {
      font-weight: bold;
    }
  }

  .wrapper {
    margin: 30px 0 !important;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;

    .item {
      width: 200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 5px;
      background: ${props => props.theme.palette.general.light};
      margin: 0 7px;
      padding: 22px 15px;
      ${bp('sm')`
        margin: 10px 5px;
      `}

      img {
        max-width: 100%;
        max-height: 135px;
        margin: auto;
        display: block;
      }

      span {
        font: ${font('default', 'medium', '18px/1.3')};
        margin: 15px 0 10px;
        display: block;
        height: 48px;
        color: ${props => props.theme.palette.general.strong};
        text-align: center;
      }

      .button {
        ${props => props.theme.css.buttonPrimary};
      }
    }
  }

  a {
    color: ${props => props.theme.palette.primary.gamma};
  }
`
